export const setThemeInStorage = (theme) => {
    localStorage.setItem('theme', theme)
}

export const getThemeInStorage = () => {
    return localStorage.getItem('theme');
}